module.exports = __webpack_public_path__ + "ec6e840a188727f2a73f02cf01ec047b.pdf";